import { gql } from '@apollo/client';

export const GET_VIRTUAL_OPS_AREAS = gql(/* GraphQL */ `
    query GetVirtualOpsAreas {
        getVirtualOpsAreas {
            id
            name
            sapId
            operationsExecutive {
                id
                firstName
                lastName
                designation
            }
            divisions {
                id
                name
                sapId
                sourceDivisionId
                sourceDivisionName
                sourceOpsAreaName
                sapOpsAreaId
                sapOpsAreaName
                manager {
                    id
                    firstName
                    lastName
                    designation
                }
                stores {
                    id
                    name
                    storeNo
                    sourceDivisionId
                    sourceDivisionName
                }
            }
        }
    }
`);

export const GET_SAP_DIVISIONS_FOR_VIRTUAL_BUILDER = gql(/* GraphQL */ `
    query GetSapDivisionsForVirtualBuilder {
        getSapDivisionsForVirtualBuilder {
            id
            name
            sapId
            opsArea {
                id
                name
            }
            stores {
                id
                name
                storeNo
            }
        }
    }
`);

export const GET_VIRTUAL_HIERARCHY_ELIGIBLE_USERS = gql(/* GraphQL */ `
    query GetVirtualHierarchyEligibleUsers {
        getVirtualHierarchyEligibleUsers {
            id
            firstName
            lastName
            designation
        }
    }
`);

export const GET_MANAGED_VIRTUAL_DIVISIONS = gql(/* GraphQL */ `
    query GetManagedVirtualDivisions {
        getManagedVirtualDivisions {
            id
            stores {
                id
                isClosed
                isPriceSurveyModuleEnabled
                advertisingZone {
                    isPriceSurveyModuleEnabled
                }
            }
        }
    }
`);

export const GET_VIRTUAL_DIVISIONS = gql(/* GraphQL */ `
    query GetVirtualDivisions {
        getVirtualDivisions {
            id
            name
            sapId
            sourceDivisionId
            sourceDivisionName
            sourceOpsAreaName
            sapOpsAreaId
            sapOpsAreaName
            manager {
                id
                firstName
                lastName
                designation
            }
            virtualOpsArea {
                id
                name
                operationsExecutive {
                    id
                    firstName
                    lastName
                    designation
                }
            }
            stores {
                id
                name
                storeNo
                sourceDivisionId
                sourceDivisionName
            }
        }
    }
`);
